// src/components/HelpPanel.js

import React from 'react';
import './HelpPanel.css'; // We will create this CSS file next

const HelpPanel = ({ isOpen, onClose, infoUrl }) => {
  return (
    // The 'open' class will be dynamically added to control the panel's visibility
    <div className={`help-panel ${isOpen ? 'open' : ''}`}>
      <div className="help-panel-header">
        <h3>Help & Information</h3>
        {/* The close button will call the onClose function passed from the parent */}
        <button className="help-panel-close-btn" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="help-panel-content">
        <iframe
          src={infoUrl}
          title="Info"
          className="help-panel-iframe"
        />
      </div>
    </div>
  );
};

export default HelpPanel;